import {IAnalyticsProvidersConfiguration} from './IAnalytics';
import AbstractAnalyticProvider from './providers/AbstractAnalyticProvider';
import GoogleTagManager from './providers/gtm/GoogleTagManager';
import {IGoogleTagManagerConfiguration} from './providers/gtm/IGoogleTagManager';
import AlgoliaManager from './providers/algolia/AlgoliaManager';
import GeneralFactory from 'coreClasses/GeneralFactory';

/**
 * Represents AnalyticsProvidersFactory
 */
class AnalyticsProvidersFactory extends GeneralFactory {
	/**
	 * Creates analytics provider
	 * @param {string} providerName - provider name
	 * @param configuration - provider configuration
	 * @returns {AbstractAnalyticProvider} - analytics provider
	 */
	create(providerName: string, configuration: IAnalyticsProvidersConfiguration): AbstractAnalyticProvider|null {
		switch (providerName) {
			case 'GTM':
				return new GoogleTagManager(this.managerRepository, configuration as IGoogleTagManagerConfiguration);
			case 'Algolia':
				return new AlgoliaManager(this.managerRepository);
			default:
				return null;
		}
	}
}

export default AnalyticsProvidersFactory;
